import HeroBanner from "../components/Home/HeroBanner/HeroBanner";
import ImageSection from "../components/Home/ImageSection/ImageSection";
import CareerOrientationSection from "../components/Home/CareerOrientationSection/CareerOrientationSection";
import LecturersSection from "../components/Home/LecturersSection/LecturersSection";
import TrainingProgramsSection from "../components/Home/TrainingProgramsSection/TrainingProgramsSection";
import FieldsSection from "../components/Home/FieldsSection/FieldsSection";
import FieldsSection2 from "../components/Home/FieldsSection2/FieldsSection2";
import FieldsSection3 from "../components/Home/FieldsSection3/FieldsSection3";
import FieldsSection4 from "../components/Home/FieldsSection4/FieldsSection4";
import ScheduleSection from "../components/Home/ScheduleSection/ScheduleSection";
import SessionCards from "../components/Home/SessionCards/SessionCards";
import SessionProducts from "../components/Home/SessionProducts/SessionProducts";
import SessionRecruitment from "../components/Home/SessionRecruitment/SessionRecruitment";
import SessionJobs from "../components/Home/SessionJobs/SessionJobs";
import FloatingButtons from "../components/Common/FloatingButtons/FloatingButtons";
import PartnersSection from "../components/Home/PartnersSection/PartnersSection";
import TrainingCoopSection from "../components/Home/TrainingCoopSection/TrainingCoopSection";
import ExpertsSaySection from "../components/Home/ExpertsSaySection/ExpertsSaySection";
const Home = () => {
  return (
    <>
      <HeroBanner />

      <section>
        <ImageSection />
      </section>

      <section id="gioi-thieu">
        <CareerOrientationSection />
      </section>

      <section id="giang-vien">
        <LecturersSection />
      </section>

      <section id="dao-tao">
        <TrainingProgramsSection />
      </section>

      <section id="nganh-nghe">
        <FieldsSection3 />
      </section>
      <section id="nganh-nghe">
        <FieldsSection2 />
      </section>
      <section id="nganh-nghe">
        <FieldsSection4 />
      </section>
      <section id="nganh-nghe">
        <FieldsSection />
      </section>

      <section id="khai-giang">
        <ScheduleSection />
      </section>

      <section id="the">
        <SessionCards />
      </section>

      <section id="cua-hang">
        <SessionProducts />
      </section>

      <section id="tuyen-dung">
        <SessionRecruitment />
      </section>

      <section id="thuc-tap">
        <SessionJobs />
      </section>
      <section id="doi-tac">
        <PartnersSection />
      </section>
      <section id="hoat-dong">
        <TrainingCoopSection />
      </section>
      <section id="chuyen-gia">
        <ExpertsSaySection />
      </section>
      <FloatingButtons />
    </>
  );
};

export default Home;
